import React from 'react'

import { useHistory } from 'react-router-dom'
import { LogOut } from 'lucide-react'

import { logout } from '../../../services/auth'
import { controllerChangelog } from '../../../services/controllers/global'

/**
 * Cabeçalho: nome da loja + sair.
 *
 * Removidos daqui: o menu suspenso com "Configurações" (o acesso continua pelo
 * menu lateral), o sino de notificações e o atalho da Universidade Petland.
 *
 * O widget do Headway CONTINUA sendo inicializado, só que sem ícone visível:
 * é ele que preenche a store `useChangelog`, consumida por `pages/Hub/Notifications`.
 * Se a âncora `.notificationId` sair daqui, aquela tela fica vazia.
 */
function Submenu() {
  const CLChangelog = controllerChangelog()

  const store = localStorage.getItem('STORE')
  const history = useHistory()

  React.useEffect(() => {
    window?.Headway?.init({
      selector: '.notificationId',
      account: 'JmjAMy',
      callbacks: {
        onWidgetReady: CLChangelog.setChangelog,
      },
      translations: {
        title: 'Notificações',
        readMore: 'Read more',
        labels: {
          new: 'News',
          improvement: 'Updates',
          fix: 'Fixes',
        },
        footer: 'Ler Mais 👉',
      },
    })
  }, [])

  const handleLogout = () => {
    if (logout()) history.push('/')
  }

  return (
    <div className="flex items-center justify-end gap-3">
      <span className="truncate max-w-[320px]">{store}</span>

      {/* âncora do Headway: alimenta as notificações do Hub, sem ícone na tela */}
      <span className="notificationId sr-only" aria-hidden="true" />

      <button
        type="button"
        onClick={handleLogout}
        title="Sair"
        aria-label="Sair"
        className="flex items-center gap-1.5 rounded border-0 bg-transparent px-2 py-1 text-sm text-zinc-600 transition-colors hover:text-scale-600 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-scale-300"
      >
        <LogOut size={20} />
        <span className="hidden sm:inline">Sair</span>
      </button>
    </div>
  )
}

export default Submenu
